/**
 * @file CanvasColumn.tsx
 * @description Колонка канвы рабочей области конструктора: уведомления над
 * канвой и сама канва (iframe витрины), общая для планшета и компьютера.
 */

import { BuilderNotices } from "../BuilderNotices";
import { BuilderCanvas } from "../canvas/BuilderCanvas";

export function CanvasColumn() {
  return (
    <div className="flex min-h-0 min-w-0 flex-col gap-2 p-3 lg:p-4">
      <BuilderNotices />
      <BuilderCanvas className="flex-1" />
    </div>
  );
}
